"use client";

import { enableStaticRendering } from "mobx-react-lite";
import React, { PropsWithChildren, useEffect } from "react";
import { container, ServiceID } from "../store";
import { StoreContext } from "../store/store.context";
import { useSession } from "next-auth/react";
import { IRootStore } from "@workspace/types";

enableStaticRendering(typeof window === "undefined");

export const StoreProvider = ({ children }: PropsWithChildren) => {
  const { data: session, status } = useSession();

  const store = container.get<IRootStore>(ServiceID.RootStore);

  useEffect(() => {
    store.auth.setSession(session ?? null, status);
  }, [session, status, store.auth]);

  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  );
};
